import React from 'react'
import InstructorGuide from './InstructorGuide'
import InstructorPanel from './InstructorPanel'
import TopInstructors from '../../homes/TopInstructors'
import Masthead from './Masthead'
import WhyTutor from './WhyTutor'
import RoleTutor from './RoleTutor'
import Testimonials from './Testimonials'
import HowItWorks from './HowItWorks'
import CallToAction from './CallToAction'

function MainContent() {
   return (
      <div>

         <Masthead />
         <WhyTutor />
         <RoleTutor />
         <Testimonials />
         <HowItWorks />
         <CallToAction />

         {/* <div className='w-full flex flex-col items-center'>
            <h1 className="text-2xl md:text-3xl font-semibold leading-snug md:leading-normal mb-4 text-dark-1
         dark:text-white">
               Become an Instructor
            </h1>
            <span className='font-sans text-gray-600 dark:text-gray-400'>
               We’re on a mission to deliver engaging, curated courses at a reasonable price.
            </span>
         </div>
         <InstructorGuide />
         <InstructorPanel />
         <TopInstructors /> */}
      </div>
   )
}

export default MainContent